<template>
  <div class="user">
    <div class="info">
      <div class="col-md-12" v-if="permissaoAdmin">
        <router-link :to="{ name: 'assinaturas' }" class="btn btn-fill btn-warning simulacoes-button">
          Assinaturas
        </router-link>
      </div>
       <div class="col-md-12" @click="fechaSide">
        <router-link :to="{ name: 'meu-perfil' }" class="btn btn-fill btn-success profile">
          Meu Perfil
        </router-link>
      </div>
      <div class="col-md-12" @click="fechaSide">
          <router-link :to="{ name: 'listar-simulacoes' }"  class="btn btn-fill btn-warning simulacoes-button">
            Minhas Simulações
          </router-link>
        </div>
        <div v-if="compartilhado.assinatura.permitirNovaSimulacao"   class="col-md-12">
          <el-select class="select-info select-menu" size="large" placeholder="Nova Simulação" v-model="simulacao" @change="redirecionar">
            <el-option v-for="item in simulacaoOpcoes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        
        <div class="col-md-12" >
          <el-select class="select-warning select-menu" size="large" placeholder="Relatórios" v-model="relatorio" @change="redirecionarRelatorios">
            <el-option v-for="item in relatorioOpcoes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

      <div class="col-md-12">
          <button class="btn btn-fill btn-danger logout" @click="sair">
            Sair
          </button>
        </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import Autenticacao from '@/services/Autenticacao'
  import Compartilhamento from '@/services/Compartilhamento'
  import Usuario from '@/services/Usuario'

  export default {
    props: {
      profileImage: {
        type: String,
        default: '/static/img/new_logo.png'
      }
    },
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data() {
      return {
        compartilhado: {
          assinatura: Compartilhamento.assinatura.dados
        },
        isClosed: true,
        simulacaoOpcoes: [{
          value: '0',
          label: 'Confinamento Avançado'
        }, {
          value: '1',
          label: 'Confinamento Básico'
        }, {
          value: '2',
          label: 'Pasto Básico'
        },
        {
          value: '3',
          label: 'Pasto Avançado'
        }
        ],
        relatorioOpcoes: [{
          value: '0',
          label: 'Consolidado'
        }
        ,{
           value: '1',
           label: 'Comparativo'
        }
        ],
      simulacao: '',
      relatorio: '',
      permissaoAdmin: false
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      fechaSide () {
        this.$sidebar.displaySidebar(false)
      },
      deveMostrarMenuAdmin () {
       Usuario.dados().then((dados) => {
        this.permissaoAdmin = dados.valor.usuario.perfil.tipo === 'admin'
       })
      },
      sair () {
        Autenticacao.sair()
          .then(() => {
            this.$router.push({
              name: 'entrar'
            })
          })
          .catch(err => console.error(err))
      },
      recarregar () {
        window && window.location && window.location.reload()
      },
      redirecionar () {
        switch (Number(this.simulacao)) {
          case 0:
            this.simulacao = ''
            this.$router.push({
              name: 'confinamento-avancado-criar'
            })
          break;
          case 1:
            this.simulacao = ''
            this.$router.push({
              name: 'confinamento-basico-criar'
            })
          break;
          case 2:
            this.simulacao = ''
            this.$router.replace({
              name: 'pasto-basico-criar'
            });
          break;
          case 3:
            this.simulacao = ''
            this.$router.replace({
              name: 'pasto-avancado-criar'
            });
          break;
        }
        this.fechaSide()
      },
      redirecionarRelatorios () {
        switch (Number(this.relatorio)) {
          case 0:
            this.relatorio = ''
            this.$router.push({
              name: 'consolidado-lista'
            })
          break;
          case 1:
            this.relatorio = ''
            this.$router.push({
              name: 'comparativo-lista'
            });
          break;
          case 2:
            this.relatorio = ''
            this.$router.push({
              name: 'temporeal-listar'
            });
          break;
        }
        this.fechaSide()
      }
    },
    created () {
      this.deveMostrarMenuAdmin()
    }
  }
</script>

<style lang="scss" scoped >

  // @media (max-width: 992px){
  //   .el-select.select-info.select-menu.el-select--large {
  //   display: none !important;
  //   }

  //   .el-select.select-warning.select-menu.el-select--large {
  //   display: none !important;
  //   }
  // }

  // .el-select.select-info.select-menu.el-select--large {
  //   display: block;
  // }

  // .el-select.select-warning.select-menu.el-select--large {
  //   display: block;
  // }
  .el-select-dropdown.el-popper {
    z-index: 99999999 !important;
  }

  .collapsed {
    transition: opacity 1s;
  }

  .btn-success,
  .btn-warning,
  .btn-info {
    &.btn-fill.active {
      opacity: 1;
    }
  }
  
  .sidebar {
     .info .col-md-12 {
       margin-bottom: 15px;
       
       .logout,
       .profile {
         width: 100%;
         border-radius: 7px;
       }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue